export const Settings = {
    contact: {
        mail: 'Marco.Gora@bosch.com',
    },
    inputLineBreakNumber: 25,
    emptyChat: 'new chat',
    allAccessRole: 'BBM_AI_PHub_ValueEngineTeam_Altair',
    expirationThreshold: 5 * 60 * 1000, // 5 minutes
    defaultAssistantImage: '/images/spaces/default.png',
    defaultAssistantImageAllowInversion: false,
    idleTimeout: 15 * 60 * 1000,        // 15 minutes of inactivity before logout
    idlePromptBeforeLogout: 60 * 1000, // show warning 60 seconds before logout
}

export const SUPPORTED_BACKEND_LANGUAGES = [
    'cs',
    'de',
    'en',
    'es',
    'hu',
    'ja',
    'ko',
    'nl',
    'pt',
    'ro',
    'ru',
    'th',
    'zh',
]

export const titleSizes = {
    1: '4xl',
    2: '3xl',
    3: '2xl',
    4: 'xl',
    5: 'l',
    6: 'm',
    7: 's',
}

export const HeaderType = {
    DEFAULT: 'header-default',
    MINIMAL: 'header-minimal',
}

export const AssistantTypes = {
    BASIC: 'basic',
    ADVANCED: 'advanced',
}

export const RenderOptions = {
    default: 'spaces',
    assistants: 'assistants',
    spaces: 'spaces',
}

export const MenuItemTypes = {
    item: 'item',
    group: 'group',
    sublabel: 'sublabel',
}

export const LoadingMessages = {
    luci: 'Hold your horses, pal. Just rummaging through our past escapades and questionable decisions. Give me a sec to load up all the chaos!',
}

export const AuthorisationStates = {
    IDLE: 'idle',
    AUTHORISING: 'authorising',
    AUTHORISED: 'authorised',
    RELOGIN: 'relogin',
    ERROR: 'error',
}
